import { SyncFn } from './sync-coordinator';
import {
  getStationSyncPosition,
  isStationOrientationMeaningful,
} from './source-positions';
import { applyToFreeView } from './apply-to-free-view';

/**
 * Syncs from a station/image source pane to a FreeView target pane.
 * Updates the look direction towards the station position and propagates
 * source quaternion + fov to the target frustum only when the source
 * orientation is meaningful (i.e. not Planar).
 */
export const syncStationToFreeView: SyncFn = async (source, target) => {
  const syncPosition = getStationSyncPosition(source);
  if (!syncPosition) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  applyToFreeView(
    target,
    targetViewer,
    sourceViewer,
    syncPosition,
    isStationOrientationMeaningful(source)
  );
};
